import warning from 'warning';
var warned = {};
export default (function (valid, message) {
    if (!valid && !warned[message]) {
        warning(false, message);
        warned[message] = true;
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/_util/warning.js
// module id = 33
// module chunks = 1